module.exports = "/_next/static/images/manThrowingKeys-13b940e88b2c95a37bbc897e33e217a4.png";